// extracted by mini-css-extract-plugin
module.exports = {"rulerIcon":"_3eff7c26"};